import gql from 'graphql-tag';

const memberfulQueries = {
  MemberfulMembers: (planFilter) => {
    const filterArg = planFilter ? `(planFilter: "${planFilter}")` : '';
    return gql`
      query {
        memberfulMembers ${filterArg} {
          id
          email
          fullName
          stripeCustomerId
          existsInBB
          subscriptions {
            id
            active
            trialEndAt
            expiresAt
            plan {
              id
              name
              priceCents
            }
          }
        }
      }
    `;
  },
  MemberfulPlans: gql`
    query {
      memberfulPlans {
        id
        name
        priceCents
      }
    }
  `,
  MemberfulMigrationPreview: (email, includeTrials = false) => {
    return gql`
      query {
        memberfulMigrationPreview (email: "${email}", includeTrials: ${includeTrials}) {
          memberfulMember {
            id
            email
            fullName
            stripeCustomerId
            subscriptions {
              id
              active
              trialEndAt
              expiresAt
              plan {
                id
                name
                priceCents
              }
            }
          }
          existingBBUser
          action
          subscriptionMappings
          warnings
        }
      }
    `;
  },
  MemberfulMigrationById: (id) => {
    return gql`
      query {
        memberfulMigrationById (id: ${id}) {
          id
          memberfulMemberId
          memberfulEmail
          memberfulFullName
          memberfulData
          bbUserId
          action
          status
          subscriptionsMigrated
          warnings
          errors
          migratedBy
          createdAt
        }
      }
    `;
  },
  MemberfulMigrationHistory: (options) => {
    return gql`
      query {
        memberfulMigrationHistory (
          input: {
            searchTerm: "${options.searchTerm}"
            limit: ${options.limit}
            offset: ${options.offset}
            orderBy: "${options.orderBy}"
            orderByDirection: "${options.orderByDirection}"
          }
        ) {
          count
          migrations {
            id
            memberfulMemberId
            memberfulEmail
            memberfulFullName
            memberfulData
            bbUserId
            action
            status
            subscriptionsMigrated
            warnings
            errors
            migratedBy
            createdAt
          }
        }
      }
    `;
  },
  MemberfulPlanMappings: gql`
    query {
      memberfulPlanMappings {
        id
        memberfulPlanId
        memberfulPlanName
        bbSubscriptionPlanId
        subscriptionPlan {
          id
          type
          subscription {
            id
            title
            author {
              id
              fullName
            }
          }
        }
      }
    }
  `,
  SubscriptionsAdminWithPlans: gql`
    query {
      subscriptionsAdminWithPlans {
        id
        title
        author {
          id
          fullName
        }
        subscriptionPlans {
          id
          type
        }
      }
    }
  `
};

export default memberfulQueries;
